import { useEffect, useRef } from "react";

import { Popover as HeadlessPopover } from "@headlessui/react";

export { PopoverButton, PopoverPanel } from "@headlessui/react";

/** Runs `onClose` when the popover goes from open to closed, however it was closed */
function CloseWatcher({ open, onClose }: { open: boolean; onClose: () => void }) {
  const wasOpenRef = useRef(open);

  useEffect(() => {
    if (wasOpenRef.current && !open) onClose();
    wasOpenRef.current = open;
  }, [open, onClose]);

  return null;
}

/** Headless UI's Popover with an `onClose` for when it closes */
export function Popover({
  onClose,
  children,
  ...props
}: React.ComponentProps<typeof HeadlessPopover> & {
  onClose?: () => void;
}) {
  return (
    <HeadlessPopover {...props}>
      {({ open, close }) => (
        <>
          {onClose && <CloseWatcher open={open} onClose={onClose} />}
          {typeof children === "function" ? children({ open, close }) : children}
        </>
      )}
    </HeadlessPopover>
  );
}
